module.exports = __webpack_public_path__ + "static/media/regedit_203.942649aa.ico";